module.exports = __webpack_public_path__ + "img/plaid-logo.0cc2f5f2.png";